module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Tie-077e6c975f517ac031d72dc2c0fa38ff.svg";